<script lang="ts">
  import type { CensusBlock, CensusSparkBlock, RoleVolumeBlock } from '@api';
  import PeriodSelector from './PeriodSelector.svelte';
  import ContributorRoles from './ContributorRoles.svelte';
  import MomentumStages from './MomentumStages.svelte';

  // The role-census + momentum sparkline strips, grouped under one titled box with
  // the period control that drives their look-back.
  //
  // The three `/v1/…/insights` blocks behind it are named as three props, because
  // only `census_spark` moves with `days`: `census` and `role_volume` classify over
  // the fixed 30-day contributor window whatever the period says, which is what
  // stops a card here from disagreeing with a badge elsewhere (doc 04 §3.1 H).
  let {
    census,
    spark,
    roleVolume,
    days = $bindable(),
    class: cls = '',
  }: {
    census: CensusBlock;
    spark: CensusSparkBlock;
    roleVolume: RoleVolumeBlock;
    days: number;
    class?: string;
  } = $props();
</script>

<section class="rounded-box border hair bg-base-100 p-5 {cls}">
  <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
    <div class="eyebrow text-base-content/70">Contributors &amp; Engagement</div>
    <PeriodSelector bind:days note="sparkline look-back" />
  </div>
  <ContributorRoles {census} {spark} {roleVolume} />
  <div class="mt-6">
    <MomentumStages {census} {spark} />
  </div>
</section>
